import { Alert, Box, Drawer, LinearProgress } from "@mui/material";
import moment from "moment";
import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
const ApiContext = createContext();
let events = {};
export default function ContextApi({ children }) {
    const [config, setConfig] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [apiError, setAPIError] = useState(false);

    const callAPI = useCallback(async (url, fields = {}, report_error = true, method = 'POST') => {
        const { baseUrl, token } = config;
        const jsonBody = fields.jsonBody || null;
        const formData = fields.formData || null;
        let body = null;
        setIsLoading(true);
        if (formData || jsonBody) {
            if (jsonBody) {
                jsonBody.token = token;
            }
            body = formData || JSON.stringify(jsonBody);
        }
        let headers = fields.headers || null;
        if (jsonBody) {
            headers = {
                'Content-Type': 'application/json',
                ...headers
            };
        }
        return fetch(`${baseUrl}${url}`, {
            headers: {
                ...headers
            },
            method,
            body
        }).then(async res => {
            try {
                setIsLoading(false);
                const response = await res.json();
                if (response && response.RETURNCODE === 0) {
                    setAPIError(false);
                } else {
                    if (report_error) {
                        setAPIError(response.RETURNMESSAGE[0] || "ERRORE");
                        throw new Error(response.RETURNMESSAGE[0] || "ERRORE")
                    }
                }
                return response;
            } catch {
                setIsLoading(false);
                return false;
            }
        });
    }, [config]);
    const registerEvent = async (event_name, data = {}) => {
        return new Promise(async (rs, rj) => {
            if (!window.global) return rj();
            const isInWebAppiOS = (window.navigator.standalone === true);
            const isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches);
            const standAlone = isInWebAppiOS || isInWebAppChrome;
            let payload = {};
            if (data) {
                payload = { ...payload, ...data, ...{ standAlone } };
            }
            if (navigator && navigator.userAgentData) {
                const { brands, mobile, platform } = navigator.userAgentData;
                payload = { ...payload, ...({ brands, mobile, platform }) };
            }
            if (window && window.location) {
                const { location = {} } = window;
                const { host = "" } = location;
                payload = { ...payload, ...{ host } };

            }
            const register = async (geoInfo = {}) => {
                if (geoInfo && geoInfo.coords) {
                    const { coords = {} } = geoInfo;
                    const { accuracy, altitude, altitudeAccuracy, heading, latitude, longitude, speed } = coords
                    payload = { ...payload, ...{ geo_info: { accuracy, altitude, altitudeAccuracy, heading, latitude, longitude, speed } } };
                }
                if (!events[event_name]) {
                    events[event_name] = Date.now();
                } else {
                    return rs(true);
                }

                try {
                    await callAPI('retail/Loyalty/User', {
                        jsonBody: {
                            id: "",
                            output_format: "json",
                            operation: "register_event",
                            values: [{ event_name, payload }],
                            token: window.global.token
                        }
                    }, false);
                } catch (rEventEx) { }

                return rs(true);

            }
            if (navigator && navigator.geolocation && navigator.geolocation.getCurrentPosition) {
                try {
                    navigator.geolocation.getCurrentPosition(register, register);
                    return true;
                } catch (err) {
                    return true;
                }
            } else {
                register();
            }
            return rs([null, true]);
        });
    }
    const saveCustomer = useCallback(async (data = {}) => {
        const params = Object.assign({}, data);
        if (params) {
            if (params.dataDiNascita && moment(params.dataDiNascita).isValid()) {
                params.dataDiNascita = parseInt(moment(params.dataDiNascita).format("YYYYMMDD"));
            }
            if (params.nome) {
                const nomeNew = params.nome;
                params.nome = nomeNew.charAt(0).toUpperCase() + nomeNew.slice(1).toLowerCase();
            }
            if (params.cognome) {
                const cognomeNew = params.cognome;
                params.cognome = cognomeNew.charAt(0).toUpperCase() + cognomeNew.slice(1).toLowerCase();
            }
            if (params.gg) delete params.gg;
            if (params.mm) delete params.mm;
            if (params.aaaa) delete params.aaaa;
            params.force_resend = (window.global || {}).force_resend || false;
        }

        const response = await callAPI('retail/Loyalty/User', {
            jsonBody: {
                output_format: "json",
                operation: "save_customer",
                values: [params],
            }
        });
        await registerEvent('registrazione', params);
        debugger;
        if (response && response.RETURNVALUES) {
            const data = response.RETURNVALUES.shift() || {};
            return data;
        } else {
            return null;
        }
    }, [config]);

    const getColori = useCallback(async (data = {}) => {
        const params = Object.assign({}, data);
        if (params && params.dataDiNascita && moment(params.dataDiNascita).isValid()) {
            params.dataDiNascita = parseInt(moment(params.dataDiNascita).format("YYYYMMDD"));
        }
        const response = await callAPI('retail/Tabelle', {
            jsonBody: {
                output_format: "json",
                operation: "get_tableview2",
                values: [{
                    "codiceTabella": "color"
                }],
            }
        });
        if (response && response.RETURNVALUES) {
            return response.RETURNVALUES
        } else {
            return null;
        }
    }, [config]);

    const getSiaCloudConfiguration = useCallback(async (data = {}) => {
        const response = await callAPI('retail/Loyalty/Config', {
            jsonBody: {
                output_format: "json",
                operation: "index",
                values: [
                    data
                ],

            }
        });
        if (response && response.RETURNVALUES) {
            const data = response.RETURNVALUES.shift() || {};
            if (data.cfg) {
                data.cfg = JSON.parse(data.cfg);
            }
            return data;
        } else {
            return null;
        }
    }, [config]);
    const getSiaCloudPermission = useCallback(async (data = {}) => {
        const response = await callAPI('retail/Loyalty/Permission', {
            jsonBody: {
                output_format: "json",
                operation: "get_permissions_list",
                values: [
                    {
                        locale: window.navigator.language,
                        ...data
                    }
                ],
            }
        });
        if (response && response.RETURNVALUES) {
            const data = response.RETURNVALUES || [];
            return data;
        } else {
            return null;
        }
    }, [config]);

    const getEnviroments = useCallback(async () => {
        const response = await callAPI('UserHome', {
            jsonBody: {
                output_format: "json",
                operation: "get_environments",
                values: [{}],
            }
        });
        if (response && response.RETURNVALUES) {
            const data = (response.RETURNVALUES || []).shift();
            return data;
        } else {
            return null;
        }
    }, [config]);
    const setCfg = (config) => {
        setConfig(config);
    }
    return (

        <ApiContext.Provider value={{
            config,
            callAPI,
            setCfg,
            getEnviroments,
            getSiaCloudConfiguration,
            getSiaCloudPermission,
            saveCustomer,
            getColori
        }}>
            {children}
            {isLoading && <Box className="api_loader">
                <LinearProgress></LinearProgress>
            </Box>}
            {apiError && <Drawer anchor={'bottom'} open={apiError !== false} onClick={() => {
                setAPIError(false)
            }}>
                <Alert severity="error">{apiError}</Alert>
            </Drawer>}


        </ApiContext.Provider>

    )
}
export const useApiContext = () => useContext(ApiContext);